import { render } from "./LeftSidebar.vue?vue&type=template&id=0090e5a2"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Layouts/LeftSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0090e5a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0090e5a2', __exports__)) {
    api.reload('0090e5a2', __exports__)
  }
  
  module.hot.accept("./LeftSidebar.vue?vue&type=template&id=0090e5a2", () => {
    api.rerender('0090e5a2', render)
  })

}


export default __exports__